import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-without-animation-home-one',
    templateUrl: './without-animation-home-one.component.html',
    styleUrls: ['./without-animation-home-one.component.scss'],
    standalone: false
})
export class WithoutAnimationHomeOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
